export const getSelected = (
  state,
  props,
) => state.transportModeSelector[props.transportMode.legCode].selected;

export const getAllSelectedTransportModesByLeg = state =>
  Object.keys(state.transportModeSelector)
    .map(legCode => ({
      legCode,
      transportModes: state.transportModeSelector[legCode].selected,
    }));

export const getAllSelectedLegs = state =>
  Object.keys(state.transportModeSelector)
    .map(legCode => state.transportModeSelector[legCode].selected)
    .reduce((a, b) => a.concat(b), []);
